import React from 'react'

/**
 * Formats an address string by adding a line break before the city
 * @param {string} address - The full address string
 * @returns {string} - The formatted address with line break
 *
 * @example
 * formatAddress("6160 Cornerstone Court East, Suite 100, San Diego, CA 92121")
 * // Returns: "6160 Cornerstone Court East, Suite 100<br/>San Diego, CA 92121"
 */
export const formatAddress = (address) => {
  if (!address || typeof address !== 'string') {
    return address
  }

  // Find the second-to-last comma (before city)
  const commas = []
  let index = address.indexOf(',')
  while (index !== -1) {
    commas.push(index)
    index = address.indexOf(',', index + 1)
  }

  if (commas.length < 2) {
    // Not enough commas, return original address
    return address
  }

  // Split at the second-to-last comma (before city)
  const cityCommaIndex = commas[commas.length - 2]
  const streetAddress = address.substring(0, cityCommaIndex)
  const cityState = address.substring(cityCommaIndex + 1).trim()

  return `${streetAddress}<br/>${cityState}`
}

/**
 * Formats an address string and returns it as JSX elements with line break before city
 * @param {string} address - The full address string
 * @returns {JSX.Element} - The formatted address as JSX
 *
 * @example
 * formatAddressJSX("6160 Cornerstone Court East, Suite 100, San Diego, CA 92121")
 * // Returns: <span>6160 Cornerstone Court East, Suite 100<br/>San Diego, CA 92121</span>
 */
export const formatAddressJSX = (address) => {
  if (!address || typeof address !== 'string') {
    return address
  }

  // Find the second-to-last comma (before city)
  const commas = []
  let index = address.indexOf(',')
  while (index !== -1) {
    commas.push(index)
    index = address.indexOf(',', index + 1)
  }

  if (commas.length < 2) {
    // Not enough commas, return original address
    return address
  }

  // Split at the second-to-last comma (before city)
  const cityCommaIndex = commas[commas.length - 2]
  const streetAddress = address.substring(0, cityCommaIndex)
  const cityState = address.substring(cityCommaIndex + 1).trim()

  return (
    <span>
      {streetAddress}
      <br />
      {cityState}
    </span>
  )
}
